import { api } from 'shared/api';
import { SpecialtyViewModel } from 'shared/types';

export interface FetchRoleSpecialtiesResponse {
    items: SpecialtyViewModel[];
    total: number;
}

export const searchRoleSpecialties = async (
    searchString: string,
    roleId: string | null = null,
    pageNum = 1,
    pageSize = 1000,
    signal?: AbortSignal
) => {
    const params = new URLSearchParams({
        searchString,
        pageNum: pageNum.toString(),
        pageSize: pageSize.toString()
    });

    if (roleId) {
        params.set('roleId', roleId);
    }

    return await api.get<FetchRoleSpecialtiesResponse>(
        `/References/SearchRoleSpecialties?${ params.toString() }`,
        undefined,
        { signal }
    );
};
